import { LAB_REPORT } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

type IDeleteTRFResponse = { status: boolean; message: string; data?: any };

export const useDeleteTRFAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (requisition_id: string, reason: string): Promise<IDeleteTRFResponse> => {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      try {
        const response: IDeleteTRFResponse = await axios
          .delete(
            `${LAB_REPORT?.TRF_GENERATE?.baseURL}?requisition_id=${encodeURIComponent(requisition_id)}&reason=${encodeURIComponent(reason)}`,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<any>) => {
            if (res?.data?.status === true) {
              return { status: true, message: res?.data?.message || "TRF deleted", data: res?.data?.data };
            }
            return { status: false, message: res?.data?.message || "Could not delete TRF" };
          })
          .catch((e: AxiosError<any>) => {
            sendCurl(e?.config?.["curlCommand"]);
            captureError(e);
            const serverMessage = e?.response?.data?.message || e?.message || "Could not delete TRF";
            return { status: false, message: serverMessage };
          });
        return response;
      } catch (e: any) {
        captureError(e);
        return { status: false, message: e?.message || "Could not delete TRF" };
      }
    },
    [dispatch],
  );

  return { execute };
};
